import React, { Component } from 'react';
import { createComponent as cc } from 'react-fela';

import MailchimpSubscribe from 'react-mailchimp-subscribe';
import { CONFIG } from '../util/config';
import { PAGES } from '../util/constants';

import SubscribeForm from './SubscribeForm';

const SubscribeWrapper = cc(_ => ({
  width: '100%',
  height: '100%',
  display: 'block',
}));

class SignupPage extends Component {
  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    setTimeout(() => {
      this.props.finished(PAGES.SUBSCRIBE_PAGE);
    }, 3500);
  }

  render() {
    const { onSuccess } = this.props;
    return (
      <SubscribeWrapper>
        <MailchimpSubscribe
          url={ CONFIG.mailchimpUrl }
          render={ ({ subscribe, status, message }) => (
            <SubscribeForm
              status={ status }
              message={ message }
              onValidated={ formData => {
                subscribe(formData);
              } }
              onSuccess={ onSuccess } />
          ) } />
      </SubscribeWrapper>
    );
  }
}

export default SignupPage;



// WEBPACK FOOTER //
// ./src/components/SignupPage.js